
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/co2-calculator",
      function () {
        return require("private-next-pages/co2-calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/co2-calculator"])
      });
    }
  